import { render } from "./ClinicImportTab.vue?vue&type=template&id=7b059000&scoped=true"
import script from "./ClinicImportTab.vue?vue&type=script&lang=js"
export * from "./ClinicImportTab.vue?vue&type=script&lang=js"

import "./ClinicImportTab.vue?vue&type=style&index=0&id=7b059000&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b059000"]])

export default __exports__